import { render, staticRenderFns } from "./img-player.vue?vue&type=template&id=3a37cec8&scoped=true"
import script from "./img-player.vue?vue&type=script&lang=js"
export * from "./img-player.vue?vue&type=script&lang=js"
import style0 from "./img-player.vue?vue&type=style&index=0&id=3a37cec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37cec8",
  null
  
)

export default component.exports